import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'

// Pages
import Home from './pages/Home'
import PrivateCleaning from './pages/PrivateCleaning'
import Housekeeping from './pages/Housekeeping'
import CommercialCleaning from './pages/CommercialCleaning'
import GalleryPage from './pages/GalleryPage'
import PricesPage from './pages/PricesPage'
import ContactPage from './pages/ContactPage'
import AboutPage from './pages/AboutPage'
import NotFound from './pages/NotFound'
import Forbidden from './pages/Forbidden'

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-brand-light text-brand-text-dark antialiased">
      {/* Scroll restoration on route change */}
      <ScrollToTop />

      {/* Navigation Header */}
      <Header />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ydelser" element={<Navigate to="/ydelser/privat-rengoering" replace />} />
          <Route path="/ydelser/privat-rengoering" element={<PrivateCleaning />} />
          <Route path="/ydelser/housekeeping" element={<Housekeeping />} />
          <Route path="/ydelser/erhvervsrengoering" element={<CommercialCleaning />} />
          <Route path="/galleri" element={<GalleryPage />} />
          <Route path="/priser" element={<PricesPage />} />
          <Route path="/om-os" element={<AboutPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/403" element={<Forbidden />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  )
}

export default App
